import React from 'react';
import Helmet from 'react-helmet';
import Link from 'gatsby-link';
import { graphql } from 'gatsby';

import Layout from '../layouts/layout';
import {
  Banner,
  PageSection,
  Grid,
  Row,
  Col,
  Icon,
  Separator,
  Instagram,
} from '../components';

import homepage from '../assets/img/homepage.jpg';
import banner from '../assets/img/banner.jpg';
import hodiny from '../assets/img/hodiny.jpg';
import logo from '../assets/logo/logo-full.svg';
import line from '../assets/illustrations/line.svg';

const INSTAGRAM_PREFIX = 'https://instagram.com/p/';

const description = `Moja cesta pohybu, učenia a objavovania sa začala pred
dvadsiatimi piatimi rokmi. Už ako 4-ročný som sníval o
futbalovej kariére. Tejto loptovej hre som sa naplno venoval
dvanásť rokov, s víziou splnenia svojho sna. Avšak moja
nenásytná zvedavosť ma priviedla k cestovaniu a spoznávaniu
iných svetových kultúr.`;

const InstagramPhoto = ({ href, likes, caption, thumbnail }) => {
  return (
    <Col xs={12} sm={6} md={4} lg={3} className="no-pad">
      <Instagram
        image={thumbnail}
        href={href}
        caption={caption}
        likes={likes}
      />
    </Col>
  );
};

const IndexPage = ({ data }) => {
  return (
    <Layout type="transparent" id="main-page">
      <Helmet
        title={`${data.site.siteMetadata.title} | Movement`}
        meta={[
          { name: 'description', content: description },
          { name: 'keywords', content: 'movement, pohyb' },
        ]}
      >
        <meta
          property="og:title"
          content={`${data.site.siteMetadata.title} | Movement`}
        />
        <meta property="og:image" content={homepage} />
      </Helmet>
      <Banner
        bgUrl={homepage}
        logo={logo.id}
        id="main-banner"
        overlay
        fullHeight
      />
      <PageSection space="large" type="beige">
        <Grid className="text-center">
          <Row>
            <Col xs={12} className="mt-xxlarge">
              <h2 className="h1 text-transform-uppercase no-mrg text-color-brick text-weight-bold mb-xxxsmall">
                Náš cieľ?
              </h2>
              <Separator
                src={line.id}
                style={{ height: '20px', width: '200px' }}
                className="mb-large"
              />
            </Col>
          </Row>
          <Row>
            <Col xs={12} mdOffset={1} md={10} className="mb-xxlarge">
              <p>
                Sme kreatívne stvorenia, disponujeme talentom pre umenie, hru,
                tanec, pohyb, hudbu, a veríme, že tieto hodnoty sú zakorenené v
                každom z nás. Preto je našou myšlienkou vzbudiť v ľuďoch
                prirodzenú všestrannosť, vďaka ktorej sme najdokonalejšími
                pohybovými bytosťami planéty. Skrze širokú škálu pohybových
                disciplín sa našim žiakom otvárajú dvere k ďalším nikdy sa
                nekončiacim možnostiam. Takto môžu spoznávať svoje telo, zlepšiť
                funkciu mozgu, nachádzať spojitosť s pozitívnymi psychologickými
                prvkami a osobnostne rásť. Prebuďme teda v našom vnútri opäť
                bezstarostné dieťa, užívajme si, objavujme, a hlavne sa hýbme.
              </p>
            </Col>
          </Row>
        </Grid>
      </PageSection>

      <PageSection space="none">
        <Banner bgUrl={banner} fullWidth data-aos="fade-up" />
      </PageSection>

      <PageSection space="large" type="beige">
        <Grid className="text-center">
          <Row>
            <Col xs={12} className="mt-xxlarge">
              <h2 className="h1 text-transform-uppercase no-mrg text-color-brick text-weight-bold mb-xxxsmall">
                Adrián Bartalos
              </h2>
              {/* <h2 className="h1 text-transform-uppercase">Movement</h2> */}
              <Separator
                src={line.id}
                style={{ height: '20px', width: '200px' }}
                className="mb-large"
              />
            </Col>
          </Row>
          <Row>
            <Col xs={12} mdOffset={1} md={10} className="mb-xxlarge">
              <p>
                Moja cesta pohybu, učenia a objavovania sa začala pred
                dvadsiatimi piatimi rokmi. Už ako 4-ročný som sníval o
                futbalovej kariére. Tejto loptovej hre som sa naplno venoval
                dvanásť rokov, s víziou splnenia svojho sna. Avšak moja
                nenásytná zvedavosť ma priviedla k cestovaniu a spoznávaniu
                iných svetových kultúr. Nové zážitky a ľudia z rôznych oblastí
                mi ponúkli nový pohľad na ľudské telo a pohyb. Nečakane som sa
                ocitol v tanečných štúdiách, v gymnastických halách a na
                hodinách vzdušnej akrobacie. Neskôr sa pridali intenzívne
                tréningy bojových športov. Svoje vedomosti naďalej rozširujem na
                workshopoch svetovo uznávaných učiteľov pohybu. Je toho na výber
                skutočne veľa, no neviem si predstaviť, že by som sa uberal iba
                jedným smerom. Uvedomil som si, že chcem spoznať pohyb v každej
                jeho forme a tak vznikla myšlienka, ktorú som sa rozhodol šíriť
                ďalej.
              </p>
            </Col>

            <Col xs={12}>
              <Link
                to="/kontakt"
                className="btn btn--large d-flex-inline align-items-middle"
              >
                Napíšte mi
              </Link>
            </Col>
          </Row>
        </Grid>
      </PageSection>

      <PageSection  data-aos="fade-up">
        <Grid>
          <Row>
            <Col xs={12} className="pt">
              <h2>
                <a
                  href="https://www.instagram.com/creativemovementstudio"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Icon name="instagram-2" size="small" /> instagram //{' '}
                  <strong>@creativemovementstudio</strong>
                </a>
              </h2>
            </Col>
          </Row>
        </Grid>
      </PageSection>
      {/* <PageSection space="none" data-aos="fade-up">
        <Row>
          {data.allInstaNode.edges.map(
            ({ node: { id, likes, caption, thumbnails } }) => (
              <InstagramPhoto
                href={`${INSTAGRAM_PREFIX}${id}`}
                likes={likes}
                caption={caption}
                thumbnail={thumbnails[4].src}
                key={id}
              />
            ),
          )}
        </Row>
      </PageSection> */}
      {/* <Banner bgUrl={adrian} fullWidth /> */}
    </Layout>
  );
};

export default IndexPage;

export const IndexPageQuery = graphql`
  query {
    site {
      siteMetadata {
        title
      }
    }

    file(name: { eq: "adrianmovement" }) {
      childImageSharp {
        banner: fluid {
          src
          srcSet
          aspectRatio
          sizes
          tracedSVG
        }
      }
    }

    # allInstaNode(sort: { fields: timestamp, order: DESC }) {
    #   edges {
    #     node {
    #       id
    #       likes
    #       caption
    #       original
    #       thumbnails {
    #         src
    #         config_width
    #         config_height
    #       }
    #     }
    #   }
    # }
  }
`;
